import { render, staticRenderFns } from "./ProForm.vue?vue&type=template&id=2ef4c4aa&"
import script from "./ProForm.vue?vue&type=script&lang=js&"
export * from "./ProForm.vue?vue&type=script&lang=js&"
import style0 from "./ProForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\DevOpsAgent\\agent1\\_work\\10\\s\\Site\\Source\\Web\\Marketing.UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef4c4aa')) {
      api.createRecord('2ef4c4aa', component.options)
    } else {
      api.reload('2ef4c4aa', component.options)
    }
    module.hot.accept("./ProForm.vue?vue&type=template&id=2ef4c4aa&", function () {
      api.rerender('2ef4c4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Views/Marketing/ProForm/ProForm.vue"
export default component.exports